import { forwardRef, Ref } from 'react';
import { styled } from '../../utils/styled';
import { Button } from '../Button';
import { ButtonProps } from '../Button/Button';

const StyledActionButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutral[200]}`,
  color: theme.palette.neutral[1000],
  height: '56px',
  whiteSpace: 'nowrap',
  minWidth: '56px',
}));

export const ActionButton = forwardRef(
  (
    { label, startIcon, ...props }: ButtonProps,
    ref: Ref<HTMLButtonElement>,
  ) => (
    <StyledActionButton
      color="neutral"
      label={label}
      ref={ref}
      startIcon={startIcon}
      variant="outlined"
      {...props}
    />
  ),
);
